<dl class="dl-horizontal m-b-0">
	{{#if app-func}}
		<dt>app-func: </dt>
		<dd>{{app-func}}</dd>
	{{/if}}
	{{#if app-edit}}
		<dt>app-edit: </dt>
		<dd>{{app-edit}}</dd>
	{{/if}}
	{{#if app-context}}
		<dt>app-context: </dt>
		<dd>{{app-context}}</dd>
	{{/if}}
</dl>
